export const SHURIKEN_PORTRAIT = '/assets/images/shuriken.png'

/** Misma normalización que Character.slugifyIssuerLabel (retratos del tablón). */
export function slugifyPortraitKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

function toSmPortraitPath(path) {
  const s = String(path || '').trim()
  if (!s || s === SHURIKEN_PORTRAIT) return null
  if (/-sm\.(png|jpe?g|webp)$/i.test(s)) return s
  return s.replace(/\.(png|jpe?g|webp)$/i, '-sm.$1')
}

/**
 * Candidatos de retrato.
 * @param {{ portrait?: string|null, slug?: string|null, name?: string|null, preferSm?: boolean }} opts
 * preferSm (cards del tablón): prioriza *-sm.png y cae a full / shuriken.
 */
export function getCharacterPortraitCandidates({
  portrait,
  slug,
  name,
  preferSm = false,
} = {}) {
  const out = []
  const push = (v) => {
    const s = String(v || '').trim()
    if (s && !out.includes(s)) out.push(s)
  }

  const portraitRaw = String(portrait || '').trim()
  if (preferSm && portraitRaw) {
    push(toSmPortraitPath(portraitRaw))
    push(portraitRaw)
  } else {
    push(portraitRaw)
  }

  const slugKey = String(slug || '').trim()
  const nameKey = slugifyPortraitKey(name)

  if (preferSm) {
    if (slugKey) {
      push(`/assets/images/${slugKey}-sm.png`)
      push(`/assets/images/${slugKey}.png`)
    }
    if (nameKey) {
      push(`/assets/images/${nameKey}-sm.png`)
      push(`/assets/images/${nameKey}.png`)
    }
  } else {
    if (slugKey) push(`/assets/images/${slugKey}.png`)
    if (nameKey) {
      push(`/assets/images/${nameKey}.png`)
      push(`/assets/images/${nameKey}-sm.png`)
    }
  }

  push(SHURIKEN_PORTRAIT)
  return out
}

/** Misma lógica que la ficha: portrait DB → slug.png → name.png → shuriken */
export function getCharacterPortraitSrc({ portrait, slug, name, preferSm = false } = {}) {
  const candidates = getCharacterPortraitCandidates({ portrait, slug, name, preferSm })
  return candidates[0] || SHURIKEN_PORTRAIT
}
